import SourceCommentView from "@ext/markdown/elements/sourceComment/edit/components/SourceCommentView";
import {
	inlineSourceCommentSchema,
	sourceCommentSchema,
} from "@ext/markdown/elements/sourceComment/edit/models/sourceCommentSchema";
import getExtensionOptions from "@ext/markdown/logic/getExtensionOptions";
import { mergeAttributes, Node } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";

export const SourceComment = Node.create({
	...getExtensionOptions({ schema: sourceCommentSchema, name: "source-comment" }),

	parseHTML() {
		return [{ tag: "source-comment" }];
	},

	renderHTML({ HTMLAttributes }) {
		return ["source-comment", mergeAttributes(HTMLAttributes)];
	},

	addNodeView() {
		return ReactNodeViewRenderer(SourceCommentView);
	},
});

export const InlineSourceComment = Node.create({
	...getExtensionOptions({ schema: inlineSourceCommentSchema, name: "inline-source-comment" }),

	parseHTML() {
		return [{ tag: "inline-source-comment" }];
	},

	renderHTML({ HTMLAttributes }) {
		return ["inline-source-comment", mergeAttributes(HTMLAttributes)];
	},

	addNodeView() {
		return ReactNodeViewRenderer(SourceCommentView);
	},
});
